import { inject } from 'aurelia-framework';
import { HttpClient, json } from 'aurelia-fetch-client';

@inject(HttpClient)
export class ImportService {
    constructor(http) {
        this.http = http;
    }

    async testRawMaterialImport(csv) {
        const formData = new FormData();
        formData.append('csv', csv);
        const response = await this.http.fetch('import/raw-material-test', { method: 'POST', body: formData });
        return await response.json();
    }

    async importRawMaterial(csv) {
        const formData = new FormData();
        formData.append('csv', csv);
        const response = await this.http.fetch('import/raw-material', { method: 'POST', body: formData });
        return await response.json();
    }

    async testScrapPriceUpdate(csv) {
        const formData = new FormData();
        formData.append('csv', csv);
        const response = await this.http.fetch('import/scrap-price-update-test', { method: 'POST', body: formData });
        return await response.json();
    }

    async scrapPriceUpdate(csv) {
        const formData = new FormData();
        formData.append('csv', csv);
        const response = await this.http.fetch('import/scrap-price-update', { method: 'POST', body: formData });
        return await response.json();
    }

    async searchSGAProfitFreeze(search) {
        const response = await this.http.fetch('import/sga-profit-freeze-search', { method: 'POST', body: json(search) });
        return await response.json();
    }

    async SGAProfitFreeze(ids) {
        const response = await this.http.fetch('import/sga-profit-freeze', { method: 'POST', body: json(ids) });
        return await response.json();
    }

    async testScrapOverrideUpdate(csv) {
        const formData = new FormData();
        formData.append('csv', csv);
        const response = await this.http.fetch('import/scrap-override-import-test', { method: 'POST', body: formData });
        return await response.json();
    }

    async scrapOverrideUpdate(csv) {
        const formData = new FormData();
        formData.append('csv', csv);
        const response = await this.http.fetch('import/scrap-override-import', { method: 'POST', body: formData });
        return await response.json();
    }
}